import { render, staticRenderFns } from "./Jobs.vue?vue&type=template&id=fffb73aa"
import script from "./Jobs.vue?vue&type=script&lang=js"
export * from "./Jobs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports